module.exports = "/images/ny-blck-8.jpg";